module.exports = __webpack_public_path__ + "img/paymentBadgeLock.9c4084f.png";